"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SYNTHETIC_SOURCE_TOKEN = void 0;
// A token for synthetic modules "source".
exports.SYNTHETIC_SOURCE_TOKEN = "synthetic";
